// extracted by mini-css-extract-plugin
export default {"dropdownBanner":"DropdownBanner_dropdownBanner__W2+38","isExpandMotionV1":"DropdownBanner_isExpandMotionV1__qHeWC","isTypeaheadOpen":"DropdownBanner_isTypeaheadOpen__xi19U"};